/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoanSearchProduct(
    idLenders,
    type,
    loanAmount,
    lvr,
    loanTerm,
    loanType,
    repaymentType,
    interestOnlyTerm,
    rateType,
    fixedTerm,
    propertyUse,
    construction,
    redrawFacility,
    offset,
    lineOfCredit,
    smsf,
    additionalRepayments,
    abilityToSplitLoan,
    lmiCapitalization,
    rewards,
    isNew
  ) {
    this.idLenders = idLenders;
    this.type = type;
    this.loanAmount = loanAmount;
    this.lvr = lvr;
    this.loanTerm = loanTerm;
    this.loanType = loanType;
    this.repaymentType = repaymentType;
    this.interestOnlyTerm = interestOnlyTerm;
    this.rateType = rateType;
    this.fixedTerm = fixedTerm;
    this.propertyUse = propertyUse;
    this.construction = construction;
    this.redrawFacility = redrawFacility;
    this.offset = offset;
    this.lineOfCredit = lineOfCredit;
    this.smsf = smsf;
    this.additionalRepayments = additionalRepayments;
    this.abilityToSplitLoan = abilityToSplitLoan;
    this.lmiCapitalization = lmiCapitalization;
    this.rewards = rewards;
    this.isNew = isNew;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanSearchProduct.Blank = function () {
    return HomeLoanSearchProduct.Build({
      idLenders: [],
      type: 'RESIDENTIAL',
      loanAmount: 0,
      lvr: 0,
      loanTerm: 0,
      loanType: 'NOT_ESSENTIAL',
      repaymentType: 'NOT_ESSENTIAL',
      interestOnlyTerm: 0,
      rateType: 'NOT_ESSENTIAL',
      fixedTerm: 0,
      propertyUse: 'NOT_ESSENTIAL',
      construction: 'NOT_ESSENTIAL',
      redrawFacility: 'NOT_ESSENTIAL',
      offset: 'NOT_ESSENTIAL',
      lineOfCredit: 'NOT_ESSENTIAL',
      smsf: 'NOT_ESSENTIAL',
      additionalRepayments: 'NOT_ESSENTIAL',
      abilityToSplitLoan: 'NOT_ESSENTIAL',
      lmiCapitalization: 'NOT_ESSENTIAL',
      rewards: 'NOT_ESSENTIAL',
      isNew: true
    });
  };

  HomeLoanSearchProduct.Build = function (data) {
    return new HomeLoanSearchProduct(
      data?.idLenders || [],
      data?.type || 'RESIDENTIAL',
      data.loanAmount || 0,
      data?.lvr || 0,
      data?.loanTerm || 0,
      data?.loanType || 'NOT_ESSENTIAL',
      data?.repaymentType || 'NOT_ESSENTIAL',
      data?.interestOnlyTerm || 0,
      data?.rateType || 'NOT_ESSENTIAL',
      data?.fixedTerm || 0,
      data?.propertyUse || 'NOT_ESSENTIAL',
      data?.construction || 'NOT_ESSENTIAL',
      data?.redrawFacility || 'NOT_ESSENTIAL',
      data?.offset || 'NOT_ESSENTIAL',
      data?.lineOfCredit || 'NOT_ESSENTIAL',
      data?.smsf || 'NOT_ESSENTIAL',
      data?.additionalRepayments || 'NOT_ESSENTIAL',
      data?.abilityToSplitLoan || 'NOT_ESSENTIAL',
      data?.lmiCapitalization || 'NOT_ESSENTIAL',
      data?.rewards || 'NOT_ESSENTIAL',
      data.isNew
    );
  };

  return HomeLoanSearchProduct;
};
